<button (click)="modalRef?.hide()" aria-label="Close" class="btn-close close" type="button"></button>
<div class="modal-body">
    <iframe #iframe [src]="url | safe" width="100%" height="100%"></iframe>
</div>

<!--<div class="modal-footer">-->
<!--    <button type="button" class="btn btn-default" (click)="modalRef.hide()">Close</button>-->
<!--</div>-->
